"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { useStepper } from "@ocr-monorepo/ui/components/stepper";
import {
  captureGrowthEvent,
  captureOnboardingCompleted,
  captureOnboardingSubscriptionSucceeded,
} from "@/lib/analytics";

export function OnboardingResultTracker({
  userId,
  outcome,
  plan,
}: {
  userId: string;
  outcome: "succeeded" | "failed";
  plan?: string;
}) {
  useEffect(() => {
    if (outcome === "failed") {
      captureGrowthEvent("onboarding_subscription_failed", {
        plan_id: plan,
        is_free: false,
        reason: "subscription_sync_failed",
      });
      return;
    }

    captureOnboardingSubscriptionSucceeded(userId, {
      plan_id: plan,
      is_free: false,
    });
    captureGrowthEvent("onboarding_step_completed", {
      step: "payment",
      plan_id: plan,
    });
    captureOnboardingCompleted(userId, {
      plan_id: plan,
      is_free: false,
    });
  }, [outcome, plan, userId]);

  return null;
}

export function CompleteStepActions() {
  const router = useRouter();
  const { setActions } = useStepper();

  useEffect(() => {
    setActions({
      onNext: () => router.replace("/dashboard"),
      disableBack: true,
    });

    const timeout = window.setTimeout(() => router.replace("/dashboard"), 8000);

    return () => {
      window.clearTimeout(timeout);
      setActions({});
    };
  }, [router, setActions]);

  return null;
}
